import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Catalog } from './components/Catalog';
import { Products } from './components/Products';
import { WhyUs } from './components/WhyUs';
import { Testimonials } from './components/Testimonials';
import { SpecialOffer } from './components/SpecialOffer';
import { Guarantee } from './components/Guarantee';
import { CTASection } from './components/CTASection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { LanguageProvider } from './components/LanguageContext';
import { LanguageToggle } from './components/LanguageToggle';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-barber-black text-white font-inter selection:bg-barber-gold selection:text-barber-black" data-id="element-1">
        <LanguageToggle data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <Problem data-id="element-5" />
          <Solution data-id="element-6" />
          <Catalog data-id="element-7" />
          <Products data-id="element-8" />
          <WhyUs data-id="element-9" />
          <Testimonials data-id="element-10" />
          <SpecialOffer data-id="element-11" />
          <Guarantee data-id="element-12" />
          <CTASection data-id="element-13" />
          <FAQ data-id="element-14" />
        </main>
        <Footer data-id="element-15" />
      </div>
    </LanguageProvider>;
}